import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { applyMasqReadOnly, checkPermission } from './validation';
// The downgrade depends only on the provider inputs, so resolve it once per
// render.
const checkOne = (user, account, roles, masqReadOnly) => {
    const effectiveUser = applyMasqReadOnly(user, account, masqReadOnly);
    return (permission, workspaceId) => checkPermission(effectiveUser, account, roles, permission, workspaceId);
};
export const PermissionsContext = createContext(null);
export function usePermissions() {
    return (useContext(PermissionsContext) ?? {
        hasPermission: () => false,
        hasAnyPermission: () => false,
        hasAllPermissions: () => false,
        hasPermissionForWorkspace: () => false,
    });
}
export function PermissionsProvider({ user, account, roles, workspaceId, masqReadOnly = false, children, }) {
    let check = checkOne(user, account, roles, masqReadOnly);
    let value = {
        hasPermission: (permission) => check(permission, workspaceId),
        hasAnyPermission: (...permissions) => permissions.some((permission) => check(permission, workspaceId)),
        hasAllPermissions: (...permissions) => permissions.every((permission) => check(permission, workspaceId)),
        hasPermissionForWorkspace: (permission, forWorkspaceId) => check(permission, forWorkspaceId),
    };
    return _jsx(PermissionsContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=react.js.map